import { SkeletonBlock } from '~/shared/ui'

export function LoadingSkeleton() {
  return (
    <div className="grid max-w-full grid-cols-4 gap-x-5 gap-y-11 pb-6">
      <SkeletonBlock className="h-[313px]" />
      <SkeletonBlock className="h-[313px]" />
      <SkeletonBlock className="h-[313px]" />
      <SkeletonBlock className="h-[313px]" />
      <SkeletonBlock className="h-[313px]" />
      <SkeletonBlock className="h-[313px]" />
    </div>
  )
}
